var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { ActionTabs } from '@backrs_ui/common-ui/src/atoms/ActionTabs';
import { AppIcon, ICON_SIZES } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';
import { BASE_NUGGET_HEIGHT, BASE_NUGGET_WIDTH, } from '@backrs_ui/common-ui/src/molecules/Nugget/BaseNugget';
import { Box, Typography } from '@mui/material';
var EDUCATIONAL_INVESTMENT_STRINGS = appStrings.modules.educationalInvestment;
var ACTION_TAB_STRINGS = appStrings.modules.actionTabs;
export var EducationalInvestmentCard = function (_a) {
    var _b;
    var variant = _a.variant;
    var _c = useState(false), showCopySuccess = _c[0], setShowCopySuccess = _c[1];
    return (_jsxs(Box, { sx: cardContainerSx(variant.type), onClick: variant.onClick, children: [_jsxs(Box, { sx: headerSx, children: [_jsxs(Box, { sx: iconRowSx, children: [_jsx(Box, { sx: iconSx, children: _jsx(AppIcon, { iconName: variant.icon, diameter: "20px", color: "Colors/Base/White" }) }), variant.type === 'LARGE' && !variant.hideActions && (_jsx(ActionTabs, { actions: [
                                    {
                                        icon: variant.hasBookmarked ? 'BookmarkCheck' : 'Bookmark',
                                        onClick: variant.onBookmark,
                                        tooltipHoverText: ACTION_TAB_STRINGS.bookmark,
                                    },
                                    {
                                        icon: 'Share06',
                                        onClick: variant.onShare,
                                        tooltipHoverText: ACTION_TAB_STRINGS.share,
                                    },
                                    {
                                        icon: 'BookmarkAdd',
                                        onClick: variant.onAddTask,
                                        tooltipHoverText: ACTION_TAB_STRINGS.task,
                                    },
                                ], showCopySuccess: showCopySuccess, onCopySuccessChange: setShowCopySuccess, borderColor: "Colors/Border/border-primary" }))] }), _jsxs(Box, { sx: titleAndDescriptionSx, children: [_jsx(Typography, { variant: "text-sm-medium", color: function (_a) {
                                    var backrs = _a.backrs;
                                    return backrs.colors['Colors/Text/text-tertiary'];
                                }, children: EDUCATIONAL_INVESTMENT_STRINGS.educationalInvestment }), _jsx(Typography, { variant: "display-xs-semibold", color: function (_a) {
                                    var backrs = _a.backrs;
                                    return backrs.colors['Colors/Text/text-primary'];
                                }, children: variant.title }), _jsx(Typography, { variant: "text-sm-regular", children: variant.description })] })] }), !!((_b = variant.toSucceedItems) === null || _b === void 0 ? void 0 : _b.length) && (_jsxs(Box, { sx: toSucceedItemsSx(variant.type), children: [_jsx(Typography, { variant: "text-sm-semibold", children: EDUCATIONAL_INVESTMENT_STRINGS.toSucceed }), variant.toSucceedItems.map(function (item) { return (_jsxs(Box, { sx: toSucceedItemSx(variant.type), children: [_jsx(Box, { sx: toSucceedItemIconSx, children: _jsx(AppIcon, { iconName: "CheckCircleBroken", diameter: "16px", color: "Brand/600" }) }), _jsx(Typography, { variant: "text-sm-regular", sx: toSucceedItemTextSx(variant.type), children: item })] }, item)); })] }))] }));
};
var toSucceedItemSx = function (variant) {
    return function (_a) {
        var backrs = _a.backrs;
        return (__assign({ display: 'flex', flexDirection: 'row', gap: backrs.spacing['spacing-sm'] }, (variant === 'SMALL' && {
            width: '100%',
        })));
    };
};
var toSucceedItemIconSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: ICON_SIZES['16px'],
        height: ICON_SIZES['16px'],
        mt: backrs.spacing['spacing-xxs'],
    });
};
var toSucceedItemTextSx = function (variant) {
    return function (_a) {
        var backrs = _a.backrs;
        return (__assign({ color: backrs.colors['Colors/Text/text-primary'] }, (variant === 'SMALL' && {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            flex: 1,
            minWidth: 0,
        })));
    };
};
var cardContainerSx = function (variant) {
    return function (_a) {
        var backrs = _a.backrs;
        return ({
            display: 'flex',
            padding: backrs.spacing['spacing-2xl'],
            flexDirection: 'column',
            borderRadius: variant === 'SMALL' ? backrs.radius['radius-4xl'] : backrs.radius['radius-xl'],
            border: "1px solid ".concat(backrs.colors['Colors/Base/Black']),
            overflow: 'hidden',
            height: variant === 'SMALL' ? BASE_NUGGET_HEIGHT : undefined,
            maxWidth: variant === 'SMALL' ? BASE_NUGGET_WIDTH : undefined,
            backgroundColor: backrs.colors['Colors/Base/White'],
            cursor: variant === 'SMALL' ? 'pointer' : undefined,
        });
    };
};
var iconSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: backrs.colors['Brand/500'],
        width: ICON_SIZES['40px'],
        height: ICON_SIZES['40px'],
        minWidth: ICON_SIZES['40px'],
        minHeight: ICON_SIZES['40px'],
        borderRadius: backrs.radius['radius-md'],
        border: "2px solid ".concat(backrs.colors['Colors/Foreground/fg-quaternary-hover']),
    });
};
var headerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        justifyContent: 'flex-end',
        position: 'relative',
        flexDirection: 'column',
        gap: backrs.spacing['spacing-sm'],
    });
};
var iconRowSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        justifyContent: 'space-between',
        position: 'relative',
        flexDirection: 'row',
        gap: backrs.spacing['spacing-sm'],
        marginBottom: backrs.spacing['spacing-lg'],
    });
};
var toSucceedItemsSx = function (variant) {
    return function (_a) {
        var backrs = _a.backrs;
        return ({
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: variant === 'SMALL' ? backrs.spacing['spacing-sm'] : backrs.spacing['spacing-md'],
            paddingTop: variant === 'SMALL' ? backrs.spacing['spacing-sm'] : backrs.spacing['spacing-2xl'],
        });
    };
};
var titleAndDescriptionSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minWidth: 0,
        gap: backrs.spacing['spacing-xs'],
    });
};
